// @flow
import api from 'common/services/api';
import type { FolloUserProfile } from '../domain/FolloUserProfile';
import CampaignAlreadyLinkedError from '../domain/CampaignAlreadyLinkedError';
import PropositionAlreadyLinkedError from '../domain/PropositionAlreadyLinkedError';
import CouldNotSignUpError from '../domain/CouldNotSignUpError';

class FolloSignUpAPI {
  async signUpWithCampaign(campaignId: string, folloUserProfile: FolloUserProfile) {
    const url = `/follo/signup/with-campaign/${campaignId}`;

    try {
      const { data } = await api.post(url, folloUserProfile);
      return data;
    } catch (e) {
      if (e.response.data.code === 'CAMPAIGN_ALREADY_LINKED') {
        throw new CampaignAlreadyLinkedError();
      } else {
        throw new CouldNotSignUpError();
      }
    }
  }

  async signUpWithProposition(propositionId: string, folloUserProfile: FolloUserProfile) {
    const url = `/follo/signup/with-proposition/${propositionId}`;

    try {
      const { data } = await api.post(url, folloUserProfile);
      return data;
    } catch (e) {
      if (e.response.data.code === 'PROPOSITION_ALREADY_LINKED') {
        throw new PropositionAlreadyLinkedError();
      } else {
        throw new CouldNotSignUpError();
      }
    }
  }
}

export default new FolloSignUpAPI();



// WEBPACK FOOTER //
// ./src/advertisers/modules/signup/services/FolloSignUpAPI.js